import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { motion, AnimatePresence } from "framer-motion";
import { Star, Quote, Filter, CheckCircle2, Search } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import '../styles/TestimonialsArchives.css';

const TestimonialsArchive = () => {
  const [reviews, setReviews] = useState([]);
  const [filter, setFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    async function fetchAllReviews() {
      const { data } = await supabase
        .from("testimonials")
        .select("*")
        .order("created_at", { ascending: false });
      if (data) setReviews(data);
    }
    fetchAllReviews();
  }, []);

  const filteredReviews = reviews.filter((r) => {
    const matchesRating = filter === "All" || r.rating === parseInt(filter);
    const matchesSearch = r.text.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          r.author.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesRating && matchesSearch;
  });

  return (
    <div className="archive-root">
      <Navbar />
      
      <div className="archive-hero">
        <div className="hero-shape"></div>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="hero-content"
        >
          <span className="badge">Community Trust</span>
          <h1>Real Stories. <span className="text-gradient">Real Security.</span></h1>
          <p>Join over 10,000+ Kenyans who have secured their future with Rift Nakuru Insurance Agencies.</p>
          
          <div className="search-bar-wrapper">
            <Search className="search-icon" size={20} />
            <input 
              type="text" 
              placeholder="Search reviews by keyword..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="archive-search-input"
            />
          </div>
        </motion.div>
      </div>

      <div className="archive-container">
        <aside className="trust-stats">
          <div className="stats-card">
            <h3>Trust Score</h3>
            <div className="big-rating">
              <span className="number">4.9</span>
              <div className="stars-box">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#eab308" color="#eab308" />)}
              </div>
            </div>
            <p className="total-label">Based on {reviews.length} verified reviews</p>
            <div className="stat-line"><CheckCircle2 size={16} color="#1e5bb8" /> <span>100% Claims Transparency</span></div>
            <div className="stat-line"><CheckCircle2 size={16} color="#1e5bb8" /> <span>Certified IRA Member</span></div>
          </div>

          <div className="filter-group">
            <label><Filter size={14} /> Filter by Rating</label>
            <div className="filter-vertical">
              {["All", "5", "4", "3", "2", "1"].map((rate) => (
                <button 
                  key={rate}
                  className={filter === rate ? "v-chip active" : "v-chip"}
                  onClick={() => setFilter(rate)}
                >
                  {rate === "All" ? "All Experiences" : `${rate} Star Reviews`}
                </button>
              ))}
            </div>
          </div>
        </aside>

        <main className="review-feed">
          <AnimatePresence mode='popLayout'>
            {filteredReviews.length > 0 ? (
              <div className="masonry-layout">
                {filteredReviews.map((item) => (
                  <motion.div 
                    layout
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    key={item.id} 
                    className="modern-review-card"
                  >
                    <Quote className="quote-icon-bg" size={60} />
                    <div className="review-rating">
                      {[...Array(item.rating)].map((_, i) => (
                        <Star key={i} size={14} fill="#eab308" color="#eab308" />
                      ))}
                    </div>
                    <p className="review-body">"{item.text}"</p>
                    <div className="review-user">
                      <div className="user-avatar">{item.author.charAt(0)}</div>
                      <div className="user-info">
                        <h4>{item.author}</h4>
                        <span>Verified Policyholder — {item.platform}</span>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="no-results-container"
              >
                <div className="no-results-icon">📂</div>
                <h2>No matches found</h2>
                <p>We couldn't find any {filter !== "All" ? filter + "-star" : ""} reviews matching "{searchTerm}".</p>
                <button className="reset-search-btn" onClick={() => {setFilter("All"); setSearchTerm("");}}>
                  Clear Filters
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default TestimonialsArchive;